import React, { Component } from 'react';
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';

import green from 'material-ui/colors/green';

import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { ajaxPost } from '../ajax';
import Typography from 'material-ui/Typography/Typography';
import Switch from 'material-ui/Switch';
import {FormControlLabel} from 'material-ui/Form';

const styles = theme => ({
      fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -15,
        marginLeft: -15,
          },
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
      select:
      {
         margin: theme.spacing.unit,
          width:400,
          display:"inline-flex"
      },
      paper:
      {
          overflow:"visible"
      },
});

class SelectDeviceDialog extends Dialog {
        state =
        {
            busy : false,
            error:"",
            employee:null,
            device:null,
            selectAll:false,
        }

        handleClose = ()=>
        {
            this.props.onClose(false);
        }

        handleAction = ()=>
        {
            this.setState({busy:true});
            if( this.state.selectAll )
                this.props.onAction(null);
            else
                this.props.onAction(this.state.device);
        }

        handleChange  = (value) =>
        {
            this.setState({
                device: value,
            });
        }
    
        getData = (input, callback) =>
        {
            ajaxPost({
                url:'/DeviceAPI/ListDevices',
                data:{
                    Search:input,
                    OfflineOnly:false,
                    ActiveOnly:true,
                },
                startIndex:0,
                maxData:50,
                onSuccess: data =>
                {
                    callback(null,
                    {
                        options:data,
                        complete:true,
                    })
                },
                finally:()=>{}
            });
        }
    
        render = ()=>
        {
            const {classes} = this.props;
            const paperProps = 
            {
                style:{"overflow":"visible"}
            }

            return (
                <div>
                    
            <Dialog
            open={true}
            aria-labelledby="form-dialog-title"
            classes={classes}
            >
            <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
            <DialogContent style={{"overflow":"visible"}}>
            {this.props.allowSelectAll &&
            <FormControlLabel
          control={
            <Switch
                onChange={(event,checked)=>this.setState({selectAll:checked})}
                checked={this.state.selectAll}
            />
          }
          label="Select all devices"
        />
        }
                <DialogContentText>
                    {this.props.caption}
                    </DialogContentText>
            <Select.Async disabled={this.state.started || this.state.selectAll}
                name="form-field-name"
                value={this.state.device} 
                onChange={this.handleChange.bind(this)} 
                loadOptions={this.getData.bind(this)} 
                backspaceRemoves={true}
                isLoading={true}
                labelKey="DeviceName"
                valueKey="ZKDeviceID"
                className={classes.select}
             />
            </DialogContent>
            <DialogActions>
            <Button onClick={this.handleClose} color="primary" disabled={this.state.busy}>
            Cancel
            </Button>
            <div className={classes.wrapper}>
                <Button disabled={this.state.busy || (this.state.device==null && !this.state.selectAll)} 
                color="primary" className={classes.button} onClick={this.handleAction}>
                {this.props.action}
                </Button>
                {this.state.busy && <CircularProgress size={30} className={classes.fabProgress} />}
            </div>
            </DialogActions>
            </Dialog>            
            </div>
            )
        }
}


export default withStyles(styles)(SelectDeviceDialog);


// WEBPACK FOOTER //
// ./src/admin/SelectDeviceDialog.js